// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__S-q8z","header":"MessagesList_header__2Ch4b","chat":"MessagesList_chat__1QLWh"};